import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../component/layout/header";
import Footer from "../../component/layout/footer";
import "./viewprofile.css";
import { useRef } from "react";
import Swal from "sweetalert2";



const TutorEditProfile = () => {
  const navigate = useNavigate();

  const [userType, setUserType] = useState("individual");

  /* ================= STATE ================= */

  const [formData, setFormData] = useState({
    full_name: "",
  institute_name: "",
    phone_code:"+91",
    phone: "",
    gender: "",
    email: "",
    area: "",           // 
    location: "",
    country: "",
    state: "",
    city: "",
    cityname: "",
    pincode: "",
    category: "",
  
    bio: "",
    website: "",
    experience: "",
    instagram: "",
    facebook: "",
    youtube: "",
    address1: "",
    address2: "",
    membership_plan: "",
    language: "",
    is_online: 0,
  is_offline: 0,
  is_home_tuition: 0,
  is_demo_available: 0,
fee_min: "",
fee_max: "",

  });

    const [agePreferences, setAgePreferences] = useState({
    under_10: 0,
    age_10_to_15: 0,
    age_16_to_25: 0,
    above_25: 0,
  });


const [availability, setAvailability] = useState([
  { day_id: 1, start_time: "09:00", end_time: "18:00", is_active: 1 },
  { day_id: 2, start_time: "09:00", end_time: "18:00", is_active: 1 },
  { day_id: 3, start_time: "09:00", end_time: "18:00", is_active: 1 },
  { day_id: 4, start_time: "09:00", end_time: "18:00", is_active: 1 },
  { day_id: 5, start_time: "09:00", end_time: "18:00", is_active: 1 },
  { day_id: 6, start_time: "09:00", end_time: "18:00", is_active: 1 },
  { day_id: 7, start_time: "09:00", end_time: "18:00", is_active: 1 },
]);


  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [allSkills, setAllSkills] = useState([]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);

  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState("");
  const [showCitySuggestions, setShowCitySuggestions] = useState(false);
  const [cityQuery, setCityQuery] = useState("");
  const [showAgeDropdown, setShowAgeDropdown] = useState(false);
  const [showAvailabilityDropdown, setShowAvailabilityDropdown] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
const [skillQuery, setSkillQuery] = useState("");
const [showSkillDropdown, setShowSkillDropdown] = useState(false);
const [filteredSkills, setFilteredSkills] = useState([]);
const [languages, setLanguages] = useState([]);
const [selectedLanguages, setSelectedLanguages] = useState([]);
const [languageSearch, setLanguageSearch] = useState("");
const [selectedCategories, setSelectedCategories] = useState([]);
const [categorySearch, setCategorySearch] = useState("");
const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
const categoryDropdownRef = useRef(null);




const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
const languageDropdownRef = useRef(null);

const skillBoxRef = useRef(null);
const skillDropdownRef = useRef(null);

// New handler for Checkboxes
const handleCheckboxChange = (e) => {
  const { name, checked } = e.target;
  setFormData(prev => ({ 
    ...prev, 
    [name]: checked ? 1 : 0 
  }));
};


const handleAvailabilityChange = (index, field, value) => {
  setAvailability(prev =>
    prev.map((day, i) =>
      i === index ? { ...day, [field]: value } : { ...day }
    )
  );
};


const toggleAvailabilityDay = (index) => {
  setAvailability(prev =>
    prev.map((day, i) =>
      i === index
        ? { ...day, is_active: day.is_active ? 0 : 1 }
        : { ...day }
    )
  );
};


const filteredLanguages = languages.filter(lang =>
  lang.language_name
    .toLowerCase()
    .includes(languageSearch.toLowerCase())
);
const filteredCategories = categories.filter(cat =>
  cat.category_name
    .toLowerCase()
    .includes(categorySearch.toLowerCase())
);





  const gradientBgStyle = {
  backgroundColor: "#ffd58a", // fallback (middle color)
  backgroundImage:
    "linear-gradient(135deg, #ffb7d2, #ffd58a, #b6e9ff)",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
};


  const handleAgeCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setAgePreferences(prev => ({
      ...prev,
      [name]: checked ? 1 : 0
    }));
  };




  


const ensureCityExists = async () => {
  if (!cityQuery || formData.city) return formData.city;

  const res = await fetch(
    "https://kalakakshaaha.com/kks/api/v1/city/create-or-get",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        city_name: cityQuery,
        state_id: formData.state,
        country_id: formData.country
      })
    }
  );

  const data = await res.json();

  if (data.success) {
    setCities(prev => [
      ...prev,
      { id: data.city_id, city_name: cityQuery }
    ]);

    return data.city_id;
  }

  return null;
};






useEffect(() => {
  const handleClickOutside = (e) => {
    if (
      languageDropdownRef.current &&
      !languageDropdownRef.current.contains(e.target)
    ) {
      setShowLanguageDropdown(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);



  /* ================= FETCH MASTER DATA ================= */

useEffect(() => {
  Promise.all([
    fetch("https://kalakakshaaha.com/kks/api/v1/countries").then(r => r.json()),
    fetch("https://kalakakshaaha.com/kks/api/v1/categories").then(r => r.json()),
    fetch("https://kalakakshaaha.com/kks/api/v1/total-skills").then(r => r.json()),
    fetch("https://kalakakshaaha.com/kks/api/v1/languages").then(r => r.json())
  ])
    .then(([c, cat, s, l]) => {
      if (c.success) setCountries(c.countries);
      if (cat.success) setCategories(cat.categories);
      if (s.success) setAllSkills(s.skills);
      if (l.success) setLanguages(l.languages);
    })
    .catch(console.error);
}, []);


  /* ================= HELPERS ================= */

  const normalizeByIdOrName = (value, list, key) => {
    if (!value || !list.length) return "";
    const byId = list.find(i => String(i.id) === String(value));
    if (byId) return String(byId.id);
    const byName = list.find(
      i => i[key]?.toLowerCase() === String(value).toLowerCase()
    );
    return byName ? String(byName.id) : "";
  };


  

  const normalizeSkill = (value) => {
    if (!value || !allSkills.length) return "";
    const byId = allSkills.find(s => String(s.id) === String(value));
    if (byId) return String(byId.id);
    const byName = allSkills.find(
      s => s.skill_title.toLowerCase() === String(value).toLowerCase()
    );
    return byName ? String(byName.id) : "";
  };


  const toggleSkill = (skillId) => {
  setSelectedSkills(prev =>
    prev.includes(skillId)
      ? prev.filter(id => id !== skillId)
      : [...prev, skillId]
  );
};


const handleSkillAdd = async () => {
  if (!skillQuery.trim() || !formData.category) return;

  const existing = filteredSkills.find(
    s => s.skill_title.toLowerCase() === skillQuery.toLowerCase()
  );

  if (existing) {
    toggleSkill(existing.id);
    setSkillQuery("");
    return;
  }

  const res = await fetch("/api/v1/skills/create", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      skill_title: skillQuery,
      category_id: formData.category
    })
  });

  const data = await res.json();

  if (data.success) {
    setAllSkills(prev => [
      ...prev,
      { id: data.id, skill_title: skillQuery, category_id: formData.category }
    ]);
    setSelectedSkills(prev => [...prev, data.id]);
    setSkillQuery("");
  }
};



  /* ================= COUNTRY → STATE ================= */

  useEffect(() => {
  if (!formData.country) {
    setStates([]);
    setCities([]);
    return;
  }

  fetch(`https://kalakakshaaha.com/kks/api/v1/states/${formData.country}`)
    .then(r => r.json())
    .then(d => {
      if (d.success) {
        setStates(d.states);
      }
    });
}, [formData.country]);


  /* ================= STATE → CITY ================= */

  useEffect(() => {
  if (!formData.state) {
    setCities([]);
    return;
  }

  fetch(`https://kalakakshaaha.com/kks/api/v1/cities/${formData.state}`)
    .then(r => r.json())
    .then(d => {
      if (d.success) {
        setCities(d.cities);
      }
    });
}, [formData.state]);

/* ================= RESET CITY WHEN STATE CHANGES ================= */

useEffect(() => {
  setFormData(p => ({ ...p, city: "" }));
  setCityQuery("");
}, [formData.state]);


useEffect(() => {
  if (formData.city && cities.length) {
    const found = cities.find(
      c => String(c.id) === String(formData.city)
    );

    if (found) {
      setCityQuery(found.city_name);
    }
  }
}, [formData.city, cities]);



  /* ================= CATEGORY → SKILLS ================= */

useEffect(() => {
  if (!selectedCategories.length) {
    setFilteredSkills([]);
    setSelectedSkills([]); // optional: clear selected skills
    return;
  }

  const filtered = allSkills.filter(skill =>
    selectedCategories.includes(Number(skill.category_id))
  );

  setFilteredSkills(filtered);

  // 🔥 Remove already-selected skills that no longer match category
  setSelectedSkills(prev =>
    prev.filter(skillId =>
      filtered.some(skill => skill.id === skillId)
    )
  );

}, [selectedCategories, allSkills]);




  



  /* ================= FETCH PROFILE ================= */



/* ================= FETCH PROFILE ================= */
// In your useEffect that fetches the profile, after you load categories:

useEffect(() => {
  const token = localStorage.getItem("token");
  
  if (!token) {
    return navigate("/login");
  }

  fetch("https://kalakakshaaha.com/kks/api/tutor/profile", {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  })
    .then(r => r.json())
    .then(async (data) => {
      if (!data.success) {
        console.error("❌ API Error:", data.message);
        alert("Error: " + data.message);
        return;
      }

      const p = data.profile;
      if (!p) {
        console.error("❌ No profile in response");
        return;
      }
   

       const detectedUserType = p.tutor_type || "individual"; // Comes from DB
        setUserType(detectedUserType);

      let categoryIds = [];
      if (p.category) {
        const categoryNames = p.category.split(",").map(c => c.trim());
        categoryIds = categories
          .filter(cat => categoryNames.includes(cat.category_name))
          .map(cat => cat.id);
      }

      setFormData({
        full_name: p.full_name || "",
      institute_name: p.institute_name || "",

        email: p.email || "",
        phone_code: p.phone_code || "+91",
        phone: p.phone || "",
        gender: p.gender || "",
        country: String(p.country_id || ""),
        state: String(p.state_id || ""),
        city: String(p.city_id || ""),
        pincode: p.pincode || "",
        area: p.area || "",
        location: p.location || "",
        category: "", // Keep empty for display purposes
        bio: p.bio || "",
        website: p.website || "",
        experience: p.experience || "",
        instagram: p.instagram || "",
        facebook: p.facebook || "",
        youtube: p.youtube || "",
        address1: p.Address_line1 || "",
        address2: p.Address_line2 || "",
        membership_plan: p.membership_plan || "",
        is_demo_available: Number(p.is_demo_available) || 0,
     fee_min: p.fee_min || "",
fee_max: p.fee_max || "",

        is_online: Number(p.is_online) || 0,
        is_offline: Number(p.is_offline) || 0,
        is_home_tuition: Number(p.is_home_tuition) || 0,
      });

      // 🔧 Set categories with parsed IDs
      setSelectedCategories(categoryIds);

      // Set skills
      setSelectedSkills(
        p.skills_list && Array.isArray(p.skills_list)
          ? p.skills_list.map(s => Number(s.id))
          : []
      );

      // Set languages
      setSelectedLanguages(
        Array.isArray(p.languages)
          ? p.languages.map(l => Number(l.id))
          : []
      );

      // Set age preferences
      if (p.age_preferences) {
        setAgePreferences({
          under_10: parseInt(p.age_preferences.under_10) || 0,
          age_10_to_15: parseInt(p.age_preferences.age_10_to_15) || 0,
          age_16_to_25: parseInt(p.age_preferences.age_16_to_25) || 0,
          above_25: parseInt(p.age_preferences.above_25) || 0,
        });
      }

      // Set availability
      const apiAvailability = Array.isArray(p.availability) ? p.availability : [];
      setAvailability(prev =>
        prev.map(day => {
          const match = apiAvailability.find(
            a => Number(a.day_id) === Number(day.day_id)
          );
          if (!match) return { ...day };
          return {
            ...day,
            start_time: match.start_time || "",
            end_time: match.end_time || "",
            is_active: Number(match.is_active) || 0
          };
        })
      );

      // Set profile image
      if (p.profile_photo) {
        setPhotoPreview(
          `https://kalakakshaaha.com/uploads/tutors/${p.profile_photo}?t=${Date.now()}`
        );
      }

      setLoading(false);
    })
    .catch(err => {
      console.error("❌ Fetch error:", err);
      alert("Error loading profile: " + err.message);
      setLoading(false);
    });
}, [navigate, categories]); // ⚠️ Add 'categories' to dependency array


useEffect(() => {
  const handleClickOutside = (e) => {
    if (
      skillBoxRef.current &&
      !skillBoxRef.current.contains(e.target) &&
      skillDropdownRef.current &&
      !skillDropdownRef.current.contains(e.target)
    ) {
      setShowSkillDropdown(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);


useEffect(() => {
  if (skillBoxRef.current) {
    skillBoxRef.current.scrollLeft =
      skillBoxRef.current.scrollWidth;
  }
}, [selectedSkills]);








/* ================= HANDLERS ================= */

 const handleChange = (e) => {
  const { name, value } = e.target;

  // Full name: only letters and space
  if (name === "full_name" && !/^[A-Za-z ]*$/.test(value)) return;
  if (name === "owner_name" && !/^[A-Za-z ]*$/.test(value)) return;

  // Phone: allow +countrycode and exactly 10 digits after it
if (name === "phone") {
  // allow + and digits only
  if (!/^\+?\d*$/.test(value)) return;

  // extract digits only
  const digits = value.replace(/\D/g, "");

  // allow max 13 digits total (+country + 10)
  if (digits.length > 13) return;
}


// ✅ PINCODE: numbers only, max 6 digits
  if (name === "pincode") {
    if (!/^\d*$/.test(value)) return;
    if (value.length > 6) return;
  }



  // Experience: only numbers
  if (name === "experience" && !/^[0-9]*$/.test(value)) return;

  setFormData(p => ({ ...p, [name]: value }));
};



  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    setPhoto(file);
    if (file) setPhotoPreview(URL.createObjectURL(file));
  };

  /* ================= VALIDATION ================= */

const validateForm = (cityIdOverride = null) => {
  const e = {};

  // 1️⃣ SIMPLE REQUIRED FIELDS
  const requiredFields = {
    full_name: "Full name",
    gender: "Gender",
    phone: "Phone",
    country: "Country",
    state: "State",
    pincode: "Pincode",
    area: "Area",
    location: "Location",
    experience: "Experience",
    address1: "Address Line 1",
    address2: "Address Line 2",
   
  
 
  };

  if (userType === "institute") {
requiredFields.institute_name = "Institute name";
  }

  Object.keys(requiredFields).forEach((field) => {
    if (!formData[field]) {
      e[field] = `${requiredFields[field]} is required`;
    }
  });

  // 2️⃣ CATEGORY (MANDATORY)
  if (!selectedCategories.length) {
    e.category = "Please select at least one category";
  }

  

  // 3️⃣ SUB CATEGORY / SKILLS (MANDATORY)
  if (!selectedSkills.length) {
    e.skills = "Please select at least one sub-category";
  }

  // 4️⃣ LANGUAGES (MANDATORY)
  if (!selectedLanguages.length) {
    e.languages = "Please select at least one teaching language";
  }

  // 5️⃣ AGE GROUP (MANDATORY)
  const hasAgeGroup = Object.values(agePreferences).some(v => v === 1);
  if (!hasAgeGroup) {
    e.age_group = "Please select at least one age group";
  }

  // 6️⃣ MODE OF CLASS (MANDATORY)
  if (
    !formData.is_online &&
    !formData.is_offline &&
    !formData.is_home_tuition
  ) {
    e.mode = "Please select at least one mode of class";
  }

  // 7️⃣ CITY (MANDATORY)
  if (!cityIdOverride) {
    e.city = "City is required";
  }

  // 8️⃣ AVAILABILITY (MANDATORY)
  const hasAvailability = availability.some(
    a => a.is_active && a.start_time && a.end_time
  );
  if (!hasAvailability) {
    e.availability = "Please set your availability";
  }

  // 9️⃣ PHONE VALIDATION
  const digits = formData.phone.replace(/\D/g, "");
  if (digits.length !== 10) {
    e.phone = "Phone number must be exactly 10 digits";
  }

  // 🔟 PINCODE VALIDATION
  if (!/^[1-9][0-9]{5}$/.test(formData.pincode)) {
    e.pincode = "Enter a valid 6-digit pincode";
  }

  // 🔟 FEE VALIDATION
if (!formData.fee_min || !formData.fee_max) {
  e.fee_min = "Enter fee range";
}
else if (
  Number(formData.fee_min) <= 0 ||
  Number(formData.fee_max) <= 0
) {
  e.fee_min = "Fee must be greater than 0";
}
else if (Number(formData.fee_min) > Number(formData.fee_max)) {
  e.fee_max = "Max fee must be greater than Min fee";
}


  setErrors(e);
  return Object.keys(e).length === 0;
};




  /* ================= SUBMIT ================= */

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     const token = localStorage.getItem("token");
//     const form = new FormData();
//     Object.entries(formData).forEach(([k,v]) => form.append(k,v));
//     if (photo) form.append("profile_photo", photo);

//     const res = await fetch(
//       "https://kalakakshaaha.com/kks/api/tutor/update",
//       {
//         method: "POST",
//         headers: { Authorization: `Bearer ${token}` },
//         body: form
//       }
//     );

//    const data = await res.json();

// if (data.success) {

//   // ✅ force new image preview
//   if (data.photo) {
//     setPhotoPreview(
//       `https://kalakakshaaha.com/uploads/tutors/${data.photo}?t=${Date.now()}`
//     );
//   }

//   alert("Tutor profile updated successfully");

//   // optional small delay so user sees image update
//   setTimeout(() => {
//     navigate("/tutor-profile");
//   }, 300);
// }


//   };

const handleSubmit = async (e) => {
  e.preventDefault();
  const fdata = new FormData(e.currentTarget);
  const finalCityname = fdata.get('cityname'); // Matches the 'name' attribute
const form = new FormData();

 //console.log(form);
  // 1️⃣ Ensure city exists
  //console.log(formData);
  let finalCityId = formData.city;
 //console.log(finalCityname);
  if (!finalCityId && cityQuery) {
    finalCityId = await ensureCityExists();
  }

  // 2️⃣ Block submit if still missing
 if (!finalCityId || !finalCityname) {
  return validateForm(null);
 }

  // 3️⃣ Validate AFTER city exists
  if (!validateForm(finalCityId)) return;

  // 4️⃣ Submit with guaranteed city id
  const token = localStorage.getItem("token");

  


// categories
selectedCategories.forEach(id =>
  form.append("categories[]", id)
);
const validSkills = selectedSkills.filter(skillId =>
  allSkills.some(
    s =>
      s.id === skillId &&
      selectedCategories.includes(Number(s.category_id))
  )
);

form.append("skills", validSkills.join(","));

// skills
form.append("skills", selectedSkills.join(","));

// languages
selectedLanguages.forEach(id =>
  form.append("languages[]", id)
);



    

  Object.entries({ ...formData, city: finalCityId }).forEach(([k, v]) =>
    form.append(k, v)
  );

    form.append("tutor_type", userType);

    Object.entries(agePreferences).forEach(([k, v]) =>
      form.append(k, v)
    );

    form.append("availability", JSON.stringify(availability));
    form.append("skills", selectedSkills.join(","));



  if (photo) form.append("profile_photo", photo);

  const res = await fetch(
    "https://kalakakshaaha.com/kks/api/tutor/update",
    {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: form
    }
  );

  const data = await res.json();

if (data.success) {
  // ✅ refresh profile image if backend sends new one
  if (data.photo) {
    setPhotoPreview(
      `https://kalakakshaaha.com/uploads/tutors/${data.photo}?t=${Date.now()}`
    );
  }
 
  Swal.fire({
    icon: "success",
    title: "Profile Updated ",
    text: "Your profile has been updated successfully.",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    width: 420,
    heightAuto: false,
    allowOutsideClick: false,
    didClose: () => {
      navigate("/tutor-profile");
    }
  });
}
else {
  Swal.fire({
    icon: "error",
    title: "Update Failed",
    text: data.message || "Something went wrong while updating profile",
    confirmButtonText: "OK",
    width: 400,
    heightAuto: false
  });
}
};





  /* ================= UI ================= */

  return (
    <Fragment>
      <Header />

      <section className="instructor-single-section padding-tb section-bg" >
        <div className="container" style={{ marginTop: 100 }} >
          <div className="fun-card p-4" style={{ ...gradientBgStyle }}>
            <h3 className="text-center mb-4">Edit Tutor Profile</h3>

            <div className="row">
              <div className="col-md-4 text-center border-end">
                <img
                  src={photoPreview || "/assets/images/art/profile_image.jpg"}
                  className="rounded-circle shadow mb-3"
                  style={{ width: 180, height: 180, objectFit: "cover" }}
                  alt="Profile"
                />
                <input type="file" className="form-control" onChange={handlePhotoChange} />
              </div>

              <div className="col-md-8">
                <form onSubmit={handleSubmit}>
                  <div className="row">

                    {/* {[
                      ["FULL NAME","full_name"],
                      ["PHONE","phone"],
                      ["EXPERIENCE","experience"],
                      ["WEBSITE","website"]
                    ].map(([l,n]) => (
                      <div className="col-md-6 mb-3" key={n}>
                        <label>{l}</label>
                        <input className="form-control" name={n} value={formData[n]} onChange={handleChange}/>
                        {errors[n] && <small className="text-danger">{errors[n]}</small>}
                      </div>
                    ))} */}

                    {/* FULL NAME */}
<div className="col-md-6 mb-3">
  <label>FULL NAME<span className="text-danger">*</span></label>
  <input
    className="form-control"
    name="full_name"
    value={formData.full_name}
    onChange={handleChange}
  />
  {errors.full_name && (
    <small className="text-danger">{errors.full_name}</small>
  )}
</div>


                    {/* ✅ OWNER NAME (ONLY IF INSTITUTE) */}
                    {userType === "institute" && (
                      <div className="col-md-6 mb-3">
                        <label>INSTITUTE NAME<span className="text-danger">*</span></label>
                        <input
                          className="form-control"
                       name="institute_name"
                      value={formData.institute_name}

                          onChange={handleChange}
                          placeholder="Enter owner's full name"
                        />
                        {errors.owner_name && (
                          <small className="text-danger">{errors.owner_name}</small>
                        )}
                      </div>
                    )}

{/* PHONE */}
<div className="col-md-6 mb-3">
  <label>PHONE<span className="text-danger">*</span></label>
      <div className="phone-row">
  <select
                        name="phone_code"
                       
                        className="form-control"
                        style={{ width: "30%" }}
                        value={formData.phone_code}
                        onChange={handleChange}
                      >
                        <option value="+91">+91 (India)</option>
                        <option value="+1">+1 (USA)</option>
                        <option value="+44">+44 (UK)</option>
                      </select>
 

  <input
    className="form-control"
    name="phone"
      style={{ width: "75%" }}
    value={formData.phone}
    onChange={handleChange}
  />
  {errors.phone && (
    <small className="text-danger">{errors.phone}</small>
  )}
</div>
</div>



                 <div className="col-md-6 mb-3">
  <label>EMAIL</label>
  <input
    className="form-control"
    name="email"
    value={formData.email}
    disabled        // ✅ NOT EDITABLE
  />
  {errors.email && (
    <small className="text-danger">{errors.email}</small>
  )}
</div>

  <div className="col-md-6 mb-3">
  <label>GENDER<span className="text-danger">*</span></label>
  <select
    className="form-control"
    name="gender"
    value={formData.gender}
    onChange={handleChange}
  >
    <option value="">Select Gender</option>
    <option value="Male">Male</option>
    <option value="Female">Female</option>
    <option value="other">Other</option>
  </select>
  {errors.gender && (
    <small className="text-danger">{errors.gender}</small>
  )}
</div>
                     
                     <div
  className="col-md-6 mb-3 position-relative"
  ref={categoryDropdownRef}
>
  <label >
    CATEGORY <span className="text-danger">*</span>
  </label>

  {/* Select box */}
  <div
    className="form-control d-flex justify-content-between align-items-center"
    style={{ cursor: "pointer", background: "#fff" }}
    onClick={() =>
      setShowCategoryDropdown(prev => !prev)
    }
  >
    <span
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "90%",
        color: selectedCategories.length ? "#000" : "#6c757d",
        fontSize: "14px"
      }}
    >
      {selectedCategories.length
        ? categories
            .filter(c => selectedCategories.includes(c.id))
            .map(c => c.category_name)
            .join(", ")
        : "Select Categories"}
    </span>

    <i
      className={`fa ${
        showCategoryDropdown ? "fa-angle-up" : "fa-angle-down"
      }`}
      style={{ fontSize: "12px", color: "#666" }}
    />
  </div>

  {/* Dropdown */}
  {showCategoryDropdown && (
    <>
      {/* backdrop */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 999
        }}
        onClick={() => setShowCategoryDropdown(false)}
      />

      <div
        className="position-absolute w-100 bg-white border rounded shadow"
        style={{
          zIndex: 1000,
          top: "100%",
          marginTop: "4px"
        }}
      >
       

        {/* Category list */}
        <div style={{ maxHeight: "200px", overflowY: "auto" }}>
          {filteredCategories.length ? (
            filteredCategories.map(cat => (
              <div
                key={cat.id}
                className="d-flex align-items-center gap-2 px-2 py-2"
                style={{
                  cursor: "pointer",
                  background: selectedCategories.includes(cat.id)
                    ? "#f8f9fa"
                    : "transparent"
                }}
                onClick={() =>
                  setSelectedCategories(prev =>
                    prev.includes(cat.id)
                      ? prev.filter(id => id !== cat.id)
                      : [...prev, cat.id]
                  )
                }
              >
                <input
                  type="checkbox"
                  className="form-check-input m-0"
                  checked={selectedCategories.includes(cat.id)}
                  readOnly
                />
                <span>{cat.category_name}</span>
              </div>
            ))
          ) : (
            <div className="text-center text-muted py-3">
              No categories found
            </div>
          )}
        </div>
      </div>
    </>
  )}

  {errors.category && (
    <small className="text-danger d-block mt-1">
      {errors.category}
    </small>
  )}
</div>

                  
                  

<div className="col-md-6 mb-3 position-relative">
  <label >SUB CATEGORY<span className="text-danger">*</span></label>

  {/* Selected Skills & Input Container */}
  <div
    ref={skillBoxRef}
    className="form-control d-flex align-items-center gap-2"
    style={{
      minHeight: "38px",
      overflowX: "auto",
      whiteSpace: "nowrap",
      flexWrap: "nowrap",
      cursor: "text",
    }}
    onClick={() => setShowSkillDropdown(true)}
  >
    {/* Render Selected Skill Badges */}
    {selectedSkills.map((id) => {
      const skill = allSkills.find((s) => s.id === id);
      if (!skill) return null;

      return (
        <span 
          key={id} 
          className="badge bg-primary d-inline-flex align-items-center" 
          style={{ flexShrink: 0 }}
        >
          {skill.skill_title}
          <i
            className="fa fa-times ms-2"
            style={{ cursor: "pointer", fontSize: "0.8em" }}
            onClick={(e) => {
              e.stopPropagation();
              toggleSkill(id);
            }}
          />
        </span>
      );
    })}

    {/* Inline Search Input */}
    <input
      type="text"
      value={skillQuery}
      onChange={(e) => setSkillQuery(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          handleSkillAdd();
        }
      }}
      placeholder={selectedSkills.length === 0 ? "Select SubCategory..." : ""}
      style={{
        border: "none",
        outline: "none",
        minWidth: "120px",
        flex: 1,
        background: "transparent",
      }}
    />
  </div>

  {/* Dropdown Menu */}
  {showSkillDropdown && (
    <div
      ref={skillDropdownRef}
      className="position-absolute w-100 bg-white border shadow-sm p-2 rounded mt-1"
      style={{
        zIndex: 1000,
        maxHeight: "200px",
        overflowY: "auto",
      }}
    >
      {filteredSkills.length > 0 ? (
        filteredSkills.map((s) => (
          <div
            key={s.id}
            className="d-flex align-items-center gap-2 px-2 py-1 dropdown-item-custom"
            style={{ cursor: "pointer", borderRadius: "4px" }}
            onClick={() => toggleSkill(s.id)}
          >
            <input
              type="checkbox"
              className="form-check-input m-0"
              checked={selectedSkills.includes(s.id)}
              readOnly
              style={{ cursor: "pointer" }}
            />
            <span className="text-dark" style={{ fontSize: "14px" }}>
              {s.skill_title}
            </span>
          </div>
        ))
      ) : (
        <div className="text-muted p-2 text-center" style={{ fontSize: "13px" }}>
          No skills found
        </div>
      )}
    </div>
  )}

  {errors.skills && (
  <small className="text-danger d-block mt-1">
    {errors.skills}
  </small>
)}

</div>







{/* EXPERIENCE */}
<div className="col-md-6 mb-3">
  <label>EXPERIENCE IN YEARS<span className="text-danger">*</span></label>
  <input
    className="form-control"
    name="experience"
    value={formData.experience}
    onChange={handleChange}
  />
  {errors.experience && (
    <small className="text-danger">{errors.experience}</small>
  )}
</div>







<div className="col-md-6 mb-3">
  <label>DEMO CLASS AVAILABLE?</label>
  <div className="d-flex gap-4 mt-2">
    <label className="d-flex align-items-center gap-1">
      <input
        type="radio"
        checked={formData.is_demo_available === 1}
        onChange={() =>
          setFormData(p => ({ ...p, is_demo_available: 1 }))
        }
      />
      Yes
    </label>

    <label className="d-flex align-items-center gap-1">
      <input
        type="radio"
        checked={formData.is_demo_available === 0}
        onChange={() =>
          setFormData(p => ({ ...p, is_demo_available: 0 }))
        }
      />
      No
    </label>
  </div>
</div>


<div className="col-md-6 mb-3">
  <label>
    FEE PER SESSION <span className="text-danger">*</span>
  </label>

  <div style={{
    display: "flex",
    alignItems: "center",
    border: "1px solid #ced4da",
    borderRadius: "4px",
    overflow: "hidden"
  }}>
    {/* Currency symbol */}
    <span style={{
      backgroundColor: "#f8f9fa",
      padding: "10px 14px",
      fontWeight: "bold",
      borderRight: "1px solid #ced4da",
      minWidth: "50px",
      textAlign: "center"
    }}>
      {countries.find(c => String(c.id) === String(formData.country))
        ?.currency_symbol || "₹"}
    </span>

    {/* Min */}
<input
  type="number"
  className="form-control border-0"
  placeholder="Min"
  value={formData.fee_min || ""}
  onChange={(e) =>
    setFormData(p => ({ ...p, fee_min: e.target.value }))
  }
  min="0"
  step="any"
  style={{ boxShadow: "none" }}
/>

    <span style={{ padding: "0 10px", fontWeight: "bold" }}>–</span>

        <span style={{
      backgroundColor: "#f8f9fa",
      padding: "10px 14px",
      fontWeight: "bold",
      borderRight: "1px solid #ced4da",
      minWidth: "50px",
      textAlign: "center"
    }}>
      {countries.find(c => String(c.id) === String(formData.country))
        ?.currency_symbol || "₹"}
    </span>

    {/* Max */}
  <input
    type="number"
    className="form-control border-0"
    placeholder="Max"
    value={formData.fee_max || ""}
    onChange={(e) =>
      setFormData(p => ({ ...p, fee_max: e.target.value }))
    }
    min="0"
    step="any"
    style={{ boxShadow: "none" }}
  />
  </div>

  {(errors.fee_min || errors.fee_max) && (
    <small className="text-danger">
      {errors.fee_min || errors.fee_max}
    </small>
  )}
</div>


<div className="col-md-6 mb-3">

  <label className="fw-bold">Mode of Class <span className="text-danger">*</span></label>
  <div className="d-flex gap-3 mt-2">
    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id="is_online"
        name="is_online"
        checked={formData.is_online == 1}
        onChange={(e) => setFormData({...formData, is_online: e.target.checked ? 1 : 0})}
      />
      <label className="form-check-label" htmlFor="is_online">Online</label>
    </div>

    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id="is_offline"
        name="is_offline"
        checked={formData.is_offline == 1}
        onChange={(e) => setFormData({...formData, is_offline: e.target.checked ? 1 : 0})}
      />
      <label className="form-check-label" htmlFor="is_offline">Offline </label>
    </div>

    <div className="form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id="is_home_tuition"
        name="is_home_tuition"
        checked={formData.is_home_tuition == 1}
        onChange={(e) => setFormData({...formData, is_home_tuition: e.target.checked ? 1 : 0})}
      />
      <label className="form-check-label" htmlFor="is_home_tuition">Home Visit</label>
    </div>
  </div>

  {errors.mode && (
  <small className="text-danger d-block mt-1">
    {errors.mode}
  </small>
)}


</div>



<div
  className="col-md-6 mb-3 position-relative"
  ref={languageDropdownRef}
>
<label >
  TEACHING LANGUAGES <span className="text-danger">*</span>
</label>


  {/* Select box */}
  <div
    className="form-control d-flex justify-content-between align-items-center"
    style={{ cursor: "pointer", background: "#fff" }}
    onClick={() =>
      setShowLanguageDropdown(prev => !prev)
    }
  >
    <span
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "90%",
        color: selectedLanguages.length ? "#000" : "#6c757d",
        fontSize: "14px"
      }}
    >
      {selectedLanguages.length
        ? languages
            .filter(l => selectedLanguages.includes(l.id))
            .map(l => l.language_name)
            .join(", ")
        : "Select Languages"}
    </span>

    <i
      className={`fa ${
        showLanguageDropdown ? "fa-angle-up" : "fa-angle-down"
      }`}
      style={{ fontSize: "12px", color: "#666" }}
    />


  </div>

  {/* Dropdown */}
  {showLanguageDropdown && (
    <>
      {/* backdrop */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 999
        }}
        onClick={() => setShowLanguageDropdown(false)}
      />

     <div
  className="position-absolute w-100 bg-white border rounded shadow"
  style={{
    zIndex: 1000,
    top: "100%",
    marginTop: "4px"
  }}
>
  {/* 🔍 Search input */}
  <div className="p-2 border-bottom">
    <input
      type="text"
      className="form-control"
      placeholder="Search language..."
      value={languageSearch}
      onChange={(e) => setLanguageSearch(e.target.value)}
      style={{ fontSize: "14px" }}
    />
  </div>

  {/* Language list */}
  <div
    style={{
      maxHeight: "180px",
      overflowY: "auto"
    }}
  >
    {filteredLanguages.length ? (
      filteredLanguages.map(lang => (
        <div
          key={lang.id}
          className="d-flex align-items-center gap-2 px-2 py-2"
          style={{
            cursor: "pointer",
            borderRadius: "4px",
            background: selectedLanguages.includes(lang.id)
              ? "#f8f9fa"
              : "transparent"
          }}
          onClick={() =>
            setSelectedLanguages(prev =>
              prev.includes(lang.id)
                ? prev.filter(id => id !== lang.id)
                : [...prev, lang.id]
            )
          }
        >
          <input
            type="checkbox"
            className="form-check-input m-0"
            checked={selectedLanguages.includes(lang.id)}
            readOnly
          />
          <span style={{ fontSize: "14px", color: "#333" }}>
            {lang.language_name}
          </span>
        </div>
      ))
    ) : (
      <div className="text-center text-muted py-3" style={{ fontSize: "14px" }}>
        No languages found
      </div>
    )}
  </div>
</div>

    </>
  )}

      {errors.languages && (
  <small className="text-danger d-block mt-1">
    {errors.languages}
  </small>
)}
</div>


                   {/* <div className="col-md-6 mb-3">
  <label>MEMBERSHIP PLAN</label>
  <select
    className="form-control"
    name="membership_plan"
    value={formData.membership_plan}
    onChange={handleChange}
  >
    <option value="">Select Plan</option>
    <option value="Premium">Premium</option>
      
    <option value="Silver">Silver</option>

    <option value="Basic">Basic</option>
  
  </select>


</div>*/}




  {/* WHO CAN YOU TEACH? (Age Groups) */}
{/* AGE GROUP SELECTION - NOW AT TOP */}
<div className="col-md-6 mb-3 position-relative">
<label >
  Whom Can You Teach? (Age Groups) <span className="text-danger">*</span>
</label>


  {/* Main Select Box */}
  <div
    className="form-control d-flex justify-content-between align-items-center"
    style={{
      background: "#fff",
      cursor: "pointer",
      minHeight: "38px"
    }}
    onClick={() => setShowAgeDropdown(!showAgeDropdown)}
  >
    <span
      style={{
        color: Object.values(agePreferences).some(val => Number(val) === 1) ? "#000" : "#6c757d",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "90%",
        fontSize: "14px"
      }}
    >
      {[
        agePreferences.under_10 == 1 ? "Under 10" : null,
        agePreferences.age_10_to_15 == 1 ? "10-15" : null,
        agePreferences.age_16_to_25 == 1 ? "16-25" : null,
        agePreferences.above_25 == 1 ? "Above 25" : null
      ].filter(Boolean).join(", ") || "Select Age Category"}
    </span>
    <i
      className={`fa ${showAgeDropdown ? "fa-angle-up" : "fa-angle-down"}`}
      style={{ fontSize: "14px", color: "#666" }}
    />



  </div>

  {/* Dropdown Menu */}
  {showAgeDropdown && (
    <Fragment>
      {/* Overlay to close dropdown when clicking outside */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 999
        }}
        onClick={() => setShowAgeDropdown(false)}
      />

      <div
        className="position-absolute w-100 shadow border rounded bg-white p-2"
        style={{
          zIndex: 1000,
          top: "100%",
          marginTop: "4px",
          maxHeight: "200px",
          overflowY: "auto"
        }}
      >
        {[
          { name: "under_10", label: "Under 10" },
          { name: "age_10_to_15", label: "10 to 15" },
          { name: "age_16_to_25", label: "16 to 25" },
          { name: "above_25", label: "Above 25" }
        ].map((age) => (
          <div
            key={age.name}
            className="d-flex align-items-center gap-2 px-2 py-2"
            style={{
              cursor: "pointer",
              borderRadius: "4px",
              background: Number(agePreferences[age.name]) === 1 ? "#f8f9fa" : "transparent"
            }}
            onClick={() =>
              handleAgeCheckboxChange({
                target: {
                  name: age.name,
                  checked: Number(agePreferences[age.name]) !== 1
                }
              })
            }
          >
            <input
              type="checkbox"
              className="form-check-input m-0"
              checked={Number(agePreferences[age.name]) === 1}
              readOnly
              style={{ cursor: "pointer", width: "16px", height: "16px" }}
            />
            <span style={{ fontSize: "14px", color: "#333", lineHeight: "1" }}>
              {age.label}
            </span>
          </div>
        ))}
      </div>
    </Fragment>
  )}

      {errors.age_group && (
  <small className="text-danger d-block mt-1">
    {errors.age_group}
  </small>
)}
</div>



{/* TUTOR AVAILABILITY (DROPDOWN) */}
<div className="col-md-6 mb-3 position-relative">
  <label >TUTOR AVAILABILITY<span className="text-danger">*</span></label>

  {/* Dropdown trigger */}
  <div
    className="form-control d-flex justify-content-between align-items-center"
    style={{ cursor: "pointer", background: "#fff" }}
    onClick={() => setShowAvailabilityDropdown(prev => !prev)}
  >
    <span
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "90%",
        color: availability.some(a => a.is_active)
          ? "#000"
          : "#6c757d"
      }}
    >
      {availability.some(a => a.is_active)
        ? availability
            .filter(a => a.is_active)
            .map(a => {
              const dayNames = [
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat",
                "Sun"
              ];
              return `${dayNames[a.day_id - 1]} (${a.start_time || "--"}–${a.end_time || "--"})`;
            })
            .join(", ")
        : "Select availability"}
    </span>

    <i
      className={`fa ${
        showAvailabilityDropdown ? "fa-angle-up" : "fa-angle-down"
      }`}
      style={{ fontSize: "12px", color: "#666" }}
    />
  </div>

  {showAvailabilityDropdown && (
    <>
      {/* backdrop */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 999
        }}
        onClick={() => setShowAvailabilityDropdown(false)}
      />

      {/* dropdown panel */}
      <div
        className="position-absolute w-100 bg-white border rounded shadow p-3"
        style={{
          zIndex: 1000,
          top: "100%",
          marginTop: "4px",
          maxHeight: "264px",
          overflowY: "auto"
        }}
      >
        {[
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ].map((day, index) => (
          <div key={day} className="mb-3">
            {/* Row 1: checkbox + day */}
            <div className="d-flex align-items-center gap-2 mb-1">
             
              <span style={{ fontWeight: 500 }}>{day}</span>
               <input
                type="checkbox"
                checked={availability[index].is_active === 1}
                onChange={() => toggleAvailabilityDay(index)}
              />
            </div>

            {/* Row 2: time inputs */}
            <div className="d-flex align-items-center gap-2 ms-4">
              <input
                type="time"
                className="form-control"
                style={{ width: 120 }}
                disabled={!availability[index].is_active}
                value={availability[index].start_time}
                onChange={e =>
                  handleAvailabilityChange(index, "start_time", e.target.value)
                }
              />

              <span style={{ fontSize: 14 }}>to</span>

              <input
                type="time"
                className="form-control"
                style={{ width: 120 }}
                disabled={!availability[index].is_active}
                value={availability[index].end_time}
                onChange={e =>
                  handleAvailabilityChange(index, "end_time", e.target.value)
                }
              />
            </div>
          </div>
        ))}
      </div>
    </>
  )}

  {errors.availability && (
  <small className="text-danger d-block mt-1">
    {errors.availability}
  </small>
)}

</div>







  <div className="col-md-6 mb-3">
                      <label>COUNTRY<span className="text-danger">*</span></label>
                      <select className="form-control" name="country" value={formData.country} onChange={handleChange}>
                        <option value="">Select Country</option>
                        {countries.map(c => (
                          <option key={c.id} value={String(c.id)}>{c.country_name}</option>
                        ))}
                      </select>
                      {errors.country && <small className="text-danger">{errors.country}</small>}
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>STATE<span className="text-danger">*</span></label>
                      <select className="form-control" name="state" value={formData.state} onChange={handleChange} disabled={!states.length}>
                        <option value="">Select State</option>
                        {states.map(s => (
                          <option key={s.id} value={String(s.id)}>{s.state_name}</option>
                        ))}
                      </select>
                      {errors.state && <small className="text-danger">{errors.state}</small>}
                    </div>



<div className="col-md-6 mb-3 position-relative">
  <label>CITY<span className="text-danger">*</span></label>

  <input
    type="text"
    name='cityname'
    id='cityname'
    className="form-control"
    placeholder="Type city name"
    value={cityQuery}
    disabled={!formData.state}
    autoComplete="off"

    onChange={(e) => {
      const value = e.target.value;
      setCityQuery(value);
      setFormData(p => ({ ...p, city: "" })); // reset city id
      setShowCitySuggestions(true);
    }}

    onFocus={() => setShowCitySuggestions(true)}
    onBlur={() => setTimeout(() => setShowCitySuggestions(false), 200)}
  />

  {/* {showCitySuggestions && (
    <div className="city-suggestions">
      {cities
        .filter(c =>
          c.city_name.toLowerCase().includes(cityQuery.toLowerCase())
        )
        .map(c => (
          <div
            key={c.id}
            className="city-suggestion-item"
            onMouseDown={() => {
              setCityQuery(c.city_name);
              setFormData(p => ({ ...p, city: c.id }));
              setShowCitySuggestions(false);
            }}
          >
            {c.city_name}
          </div>
        ))}
    </div>
  )} */}


  {showCitySuggestions &&
  cities.filter(c =>
    c.city_name.toLowerCase().includes(cityQuery.toLowerCase())
  ).length > 0 && (
    <div className="city-suggestions">
      {cities
        .filter(c =>
          c.city_name.toLowerCase().includes(cityQuery.toLowerCase())
        )
        .map(c => (
          <div
            key={c.id}
            className="city-suggestion-item"
            onMouseDown={() => {
              setCityQuery(c.city_name);
              setFormData(p => ({ ...p, city: c.id }));
              setShowCitySuggestions(false);
            }}
          >
            {c.city_name}
          </div>
        ))}
    </div>
)}


  {errors.city && <small className="text-danger">{errors.city}</small>}
</div>


   

   <div className="col-md-6 mb-3">
  <label>AREA<span className="text-danger">*</span></label>
  <input
    className="form-control"
    name="area"
    value={formData.area}
    onChange={handleChange}
    placeholder="Eg: Indiranagar"
  />
  {errors.area && (
    <small className="text-danger">{errors.area}</small>
  )}
</div>

<div className="col-md-6 mb-3">
  <label>LOCATION<span className="text-danger">*</span></label>
  <input
    className="form-control"
    name="location"
    value={formData.location}
    onChange={handleChange}
    placeholder="Eg: Near Metro Station"
  />
  {errors.location && (
    <small className="text-danger">{errors.location}</small>
  )}
</div>


                


                    
<div className="col-md-6 mb-3">
  <label>ADDRESS LINE 1<span className="text-danger">*</span></label>
  <input
    className="form-control"
    name="address1"
    value={formData.address1}
    onChange={handleChange}
  />
  {errors.address1 && (
    <small className="text-danger">{errors.address1}</small>
  )}
</div>

<div className="col-md-6 mb-3">
  <label>PINCODE/ZIP<span className="text-danger">*</span></label>
  <input
    className="form-control"
    name="pincode"
    value={formData.pincode}
    onChange={handleChange}
    placeholder="Enter 6-digit pincode"
  />
  {errors.pincode && (
    <small className="text-danger">{errors.pincode}</small>
  )}
</div>

<div className="col-md-6 mb-3">
  <label>ADDRESS LINE 2<span className="text-danger">*</span></label>
  <input
    className="form-control"
    name="address2"
    value={formData.address2}
    onChange={handleChange} 
  />

   {errors.address2 && (
    <small className="text-danger">{errors.address2}</small>
  )}
</div>

{/* WEBSITE */}
<div className="col-md-6 mb-3">
  <label>WEBSITE</label>
  <input
    className="form-control"
    name="website"
    value={formData.website}
    onChange={handleChange}
  />

</div>

                    <div className="col-md-6 mb-3">
  <label>INSTAGRAM</label>
  <input
    className="form-control"
    name="instagram"
    value={formData.instagram}
    onChange={handleChange}
    placeholder="https://www.instagram.com/yourprofile"
  />

</div>

<div className="col-md-6 mb-3">
  <label>FACEBOOK</label>
  <input
    className="form-control"
    name="facebook"
    value={formData.facebook}
    onChange={handleChange}
    placeholder="https://www.facebook.com/yourpage"
  />

</div>

<div className="col-md-6 mb-3">
  <label>YOUTUBE</label>
  <input
    className="form-control"
    name="youtube"
    value={formData.youtube}
    onChange={handleChange}
    placeholder="https://www.youtube.com/@yourchannel"
  />

</div>


                    <div className="col-md-12 mb-3">
                      <label>BIO</label>
                      <textarea className="form-control" rows="3" name="bio" value={formData.bio} onChange={handleChange}/>

                    </div>





                  </div>

                 <button className="lab-btn mt-3"><span>Update</span></button>
                  <button type="button" className="lab-btn btn-secondary ms-3" onClick={() => navigate("/tutor-profile")}>
                    <span>Cancel</span>
                  </button>

                </form>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </Fragment>
  );
};

export default TutorEditProfile;
